var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product_carousel"},[_c('vue-flux',{ref:"slider",attrs:{"options":_vm.fluxOptions,"images":_vm.fluxImages,"transitions":_vm.fluxTransitions}}),_c('img',{staticClass:"original",attrs:{"src":require("../../assets/images/icons/newhome/carousel/original.png")}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }